import { memo, ReactNode, useCallback, useContext } from 'react'
import cn from 'classnames'

import { TabContext } from '../TabContext'

import s from './Tab.module.less'

interface IProps {
  children: ReactNode
  tabId: string
  className?: string
}

export const Tab = memo(function Tab({ className, tabId, ...props }: IProps) {
  const { currentTab, setCurrentTab } = useContext(TabContext)

  const handleSetCurrentTab = useCallback(() => {
    setCurrentTab(tabId)
  }, [setCurrentTab, tabId])

  return (
    <div
      onClick={handleSetCurrentTab}
      className={cn(s.root, className, {
        [s.active]: currentTab === tabId
      })}
      {...props}
    />
  )
})
